import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingCards } from './PricingCards';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 md:py-32 px-4 bg-dark-card/50 border-t border-dark-border relative overflow-hidden" data-id="element-116">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-117" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-118">
        <div className="mb-16" data-id="element-119">
          <CountdownTimer data-id="element-120" />
        </div>

        <PricingCards data-id="element-121" />

        <div className="mt-16 flex flex-wrap justify-center items-center gap-6 md:gap-8 text-sm md:text-base text-gray-400" data-id="element-122">
          <div className="flex items-center gap-2" data-id="element-123">
            <Lock className="w-5 h-5 text-gold" data-id="element-124" />
            <span data-id="element-125">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-126">
            <Zap className="w-5 h-5 text-gold" data-id="element-127" />
            <span data-id="element-128">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-129">
            <Shield className="w-5 h-5 text-gold" data-id="element-130" />
            <span data-id="element-131">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2 w-full justify-center mt-4 md:mt-0 md:w-auto" data-id="element-132">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-133" />
            <span data-id="element-134">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}